import { useEffect, useState } from "react";
import AllChats from "./AllChats";
import classes from "./Chat.module.css";
import ChatDetail from "./ChatDetail";
import { useSelector } from "react-redux";
import { JService } from "../../api-service/ApiService";
import { enqueueSnackbar } from "notistack";

const Chat = () => {
  const { canBlockCandidates } = useSelector(
    (state) => state?.auth?.permissions
  );

  //States
  const [chatDetails, setChatDetails] = useState({});
  const [blockedList, setBlockedList] = useState([]);

  //Handlers
  const getOpenedChatDetails = (c) => {
    setChatDetails(c);
  };

  const getBlockedList = () => {
    JService.get("/api/v1/auth/blocked-list/")
      .then((res) => {
        if (!res?.success)
          throw new Error(res?.message || "Could not retrieve Block list");

        if (res?.data && Array.isArray(res.data)) {
          setBlockedList(res?.data);
        }
      })
      .catch((error) => enqueueSnackbar(error?.message, { variant: "error" }));
  };

  //Effects
  useEffect(() => {
    if (canBlockCandidates) {
      getBlockedList();
    }
  }, [canBlockCandidates]);

  return (
    <div className="whatsapp-screen-container">
      <div className={classes.container}>
        <AllChats getOpenedChatDetails={getOpenedChatDetails} />
        <ChatDetail
          getBlockedList={getBlockedList}
          chatDetails={chatDetails}
          blockedList={blockedList}
        />
      </div>
    </div>
  );
};

export default Chat;
